// Startlijst "Vlees, saus & olie" — geteld juli 2026 (getelde aantallen als beginvoorraad).
// Losse tel-voorraad (vrieshuis Arctic / koelcel), NIET gekoppeld aan productie-invoer.
export const VSO_CATEGORIES = ["Vlees", "Marinade/saus", "Olie", "Kaas/zuivel", "Overig"];
export const VSO_EENHEDEN = ["kg", "Jerrycan", "Vat", "Stuks", "Doos", "Liter"];

export const VSO_SEED = [
  { a: "2360", n: "Chicken Karaage wet marinade CL", c: "Marinade/saus", e: "Jerrycan", p: 4.34, l: "Master Mix", q: 58 },
  { a: "", n: "Kip kappen", c: "Vlees", e: "kg", p: 1, l: "van Miert", q: 970 },
  { a: "", n: "Ham", c: "Vlees", e: "kg", p: 2.67, l: "Clazing", q: 584 },
  { a: "", n: "Kaas", c: "Kaas/zuivel", e: "kg", p: 4.95, l: "A-Ware", q: 1207.5 },
  { a: "", n: "Aromav", c: "Marinade/saus", e: "Jerrycan", p: 35.53, l: "Solina", q: 5 },
  { a: "", n: "Soja Olie", c: "Olie", e: "Vat", p: 1081, l: "Oiltrade", q: 7 },
  { a: "", n: "Dijenvlees", c: "Vlees", e: "kg", p: 3.54, l: "mr John", q: 10000 },
  { a: "", n: "Dijenvlees blokjes restjes", c: "Vlees", e: "kg", p: 4.54, l: "Vriesekoop", q: 1560 },
  { a: "", n: "Kipfilet haasjes 40+", c: "Vlees", e: "kg", p: 4, l: "Vriesekoop", q: 6690 },
  { a: "", n: "Cartilage baader", c: "Vlees", e: "kg", p: 1.8, l: "Vriesekoop", q: 6850 },
  { a: "", n: "Baader donker", c: "Vlees", e: "kg", p: 1.2, l: "Vriesekoop", q: 2069 },
  { a: "", n: "Vellen", c: "Vlees", e: "kg", p: 0.5, l: "Vriesekoop", q: 6000 },
  { a: "", n: "Vleugels plat dik", c: "Vlees", e: "kg", p: 1.91, l: "van Miert", q: 6433 },
  { a: "", n: "Ham/Kaas", c: "Vlees", e: "kg", p: 3.85, l: "Clazing", q: 76 },
  { a: "", n: "Vleugels dik", c: "Vlees", e: "kg", p: 1.4, l: "Clazing", q: 2800 },
  { a: "", n: "Kipfilet haasjes 44-54 gr", c: "Vlees", e: "kg", p: 4.2, l: "MHP trade", q: 15616 },
  { a: "", n: "Kipfilet 90-110 gr", c: "Vlees", e: "kg", p: 4.3, l: "MHP trade", q: 28960 },
  { a: "", n: "Kipfilet 110-130 gr", c: "Vlees", e: "kg", p: 3.85, l: "MHP trade", q: 33360 },
  { a: "", n: "Kipfilet se/st", c: "Vlees", e: "kg", p: 3.5, l: "Clazing", q: 42880 },
  { a: "", n: "Kipfilet haasjes se/st", c: "Vlees", e: "kg", p: 3.5, l: "Clazing", q: 2030 },
];
